import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Trending from './components/Trending';
import Categories from './components/Categories';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import { faqs } from '@/mocks/mangaData';

function SeoScripts() {
  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '樱花漫画',
        alternateName: '樱花漫画追更提醒',
        description:
          '樱花漫画追更提醒服务，提供收藏订阅、书架管理、追更进度自动同步与缓存下载离线阅读。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '樱花漫画 - 追更提醒、缓存下载、收藏订阅',
        description:
          '樱花漫画追更不怕漏，更新第一时间提醒，支持缓存下载离线看，收藏订阅书架管理，追更进度自动同步。',
        inLanguage: 'zh-CN',
        isPartOf: { '@type': 'WebSite', name: '樱花漫画' },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: { '@type': 'Answer', text: f.answer },
        })),
      },
    ];
    const nodes = schemas.map((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });
    return () => nodes.forEach((node) => node.remove());
  }, []);

  return null;
}

function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" />
    </a>
  );
}

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950">
      <SeoScripts />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Trending />
        <Categories />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}